import { type FC, useCallback, useState } from 'react';
import styles from './Header.module.scss';
import logo from 'src/redesign/assets/logo.png';
import { Navigation } from './components/Navigation';
import { NewSitePopup } from '../NewSitePopup';
import { SitesDropdown } from 'src/redesign/features/Header/components/Dropdown';
import { Link, useHistory } from 'react-router-dom';
import { SwitchButton } from 'src/redesign/components/SwitchButton';
import { accountActions } from 'src/redesign/features/Account/store/reducer';
import { useAppDispatch } from 'src/hooks';

export const Header: FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [isAddSitePopupVisible, setIsAddSitePopupVisible] = useState(false);
  const handleOnAddSiteClick = () => {
    setIsAddSitePopupVisible(true);
  };
  const handleAddSitePopupClose = () => {
    setIsAddSitePopupVisible(false);
  };


  const handleSwitchRole = useCallback((role: string) => {
    if (role === 'Attendee') {
      dispatch(accountActions.switchRole('attendee'));
      history.replace('/attendee-dashboard');
      return;
    }
    dispatch(accountActions.switchRole('host'));
    history.replace('/events');

  }, [dispatch, history]);

  return (
    <header className={styles.header}>
      <div className={styles.content}>
        <div className={styles.leftContent}>
          <Link to="/">
            <img className={styles.logo} src={logo} alt="logo" />
          </Link>
          <SitesDropdown onAddSiteClick={handleOnAddSiteClick} />
        </div>

        <div style={{ margin: '0 12px' }}>
          <SwitchButton onChange={handleSwitchRole} items={['Host', 'Attendee']} />
        </div>

        <Navigation />
      </div>
      <NewSitePopup isOpen={isAddSitePopupVisible} onClose={handleAddSitePopupClose} />
    </header>
  );
};
